import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const AddButton = styled.div`
  display: flex;
  align-items: center;
  color: ${Variables.colors.tertiary_800};
  font-size: ${Variables.font_sizes.medium};
  padding: 4px 0;
  cursor: pointer;
  & > .icon {
    font-size: 16px;
    margin-left: 8px;
  }
  &:hover {
    color: ${Variables.colors.tertiary_700};
  }
`;
export const LevelLabel = styled.div`
  font-size: ${Variables.font_sizes.medium};
  width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Flex = styled.div`
  position: relative;
  display: flex;
  background-color: inherit;
  .title {
    font-size: ${Variables.font_sizes.x_medium};
    line-height: 1.6;
  }
  .switch-wrapper {
    display: flex;
    align-items: center;
  }
  flex-direction: ${props => {
    switch (props.direction) {
      case "col":
      case "column":
        return "column";
      case "col-reverse":
      case "column-reverse":
        return "column-reverse";
      case "row":
        return "row";
      case "row-reverse":
        return "row-reverse";
      default:
        return "row";
    }
  }};
  ${props =>
    props.marginBottom && "margin-bottom: " + props.marginBottom * 10 + "px;"};
  ${props => props.marginTop && "margin-top: " + props.marginTop * 10 + "px;"};
  border-color: ${Variables.colors.complementary_400};
  ${props =>
    props.borderBottom &&
    "border-bottom: " + (props.borderBottom || 1) + "px;"};
  &:last-child {
    border-bottom: 0;
  }
  align-items: ${props => {
    switch (props.align) {
      case "between":
        return "space-between";
      case "arround":
        return "space-around";
      case "center":
        return "center";
      case "start":
        return "flex-start";
      case "end":
        return "flex-end";
      default:
        return "center";
    }
  }};
  justify-content: ${props => {
    switch (props.justify) {
      case "between":
        return "space-between";
      case "arround":
        return "space-around";
      case "center":
        return "center";
      case "start":
        return "flex-start";
      case "end":
        return "flex-end";
      default:
        return "space-between";
    }
  }};

  .text-input-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: inherit;
    margin-right: 4px;
    flex: 1;
    & > div {
      background-color: inherit;
      input {
        background-color: inherit;
      }
      label {
        background-color: inherit;
        color: ${Variables.colors.complementary_500};
        font-weight: ${Variables.font_weight.light};
        &:after {
          background-color: inherit !important;
        }
      }
    }
  }
`;

export const Box = styled.div`
  //max-width: calc(410px + 32px);
  width: 100%;
  margin-top: 10px;
  padding: 10px 16px;
  border-radius: 5px;
  background-color: ${Variables.colors.complementary_200};
  color: ${Variables.colors.complementary_800};

  .event-info-icon {
    width: 40px;
    height: 40px;
    display: flex;
    -webkit-box-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    align-items: center;
    cursor: pointer;
    border-radius: 50%;
    &:before {
      font-size: 20px;
      color: ${Variables.colors.complementary_600};
      margin: 0px;
    }
    &:hover {
      background-color: ${Variables.colors.complementary_400};
    }
  }
`;

export const InputWrapper = styled.div`
  width: 100%;
  ${props => props.maxWidth && "max-width: " + props.maxWidth};
  background-color: inherit;
  .row-inputs {
    display: flex;
    align-items: center;
    justify-content: space-between;
    & > div {
      width: calc(50% - 4px);
    }
  }
  & > div {
    background-color: inherit;
    input {
      background-color: inherit;
    }
    label {
      background-color: inherit;
      &:after {
        background-color: inherit !important;
      }
    }
  }
`;

export const Delete = styled.i`
  margin-right: 10px;
  min-width: 40px;
  min-height: 40px;
  max-width: 40px;
  max-height: 40px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  &:before {
    font-size: 20px;
    color: ${Variables.colors.complementary_600};
    margin: 0;
  }
  &:hover {
    background-color: ${Variables.colors.complementary_400};
  }
`;

export const Message = styled.p`
  font-size: 12px;
  line-height: 1.58;
  color: ${Variables.colors.complementary_600};
  max-width: ${props => props.maxWidth || "470px"};
`;
